import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { instagramAdsetSetup } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, iInstagramAdsetCreateDTO } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addInstagramAdset = createAsyncThunk<
	any,
	iInstagramAdsetCreateDTO,
	{ rejectValue: iStateMessage }
>(
	curriedGetThunkName("addInstagramAdset"),
	async (payload, { rejectWithValue }) => {
		try {
			const response = await instagramAdsetSetup.createinstagramAdset(payload);

			if (!response) {
				return rejectWithValue({ message: "No response received" });
			}


			const { httpStatusCode, data, message } = response;

			// data.data.id is the actual ID
			const adsetId = data?.data?.id;

			if (httpStatusCode === 200 && adsetId) {
				return {
					data: {
						id: adsetId,
					},
					message: "AdSet created successfully",
				};
			}

			return rejectWithValue({
				httpStatusCode,
				message: message || "Unknown error",
			});

		} catch (error) {

			return rejectWithValue({
				message: "Something went wrong",
			});
		}
	}
);



export const getInstagramAdsetList = createAsyncThunk<
	iGenericResponse<any | null> | null,
	void,
	{
		rejectValue: iStateMessage;
	}
>(
	curriedGetThunkName("getInstagramAdsetList"),
	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
	async (arg, { rejectWithValue }) => {
		try {
			const response = await instagramAdsetSetup.getinstagramAdset();
			if (response) {
				const { httpStatusCode, data, message } = response;

				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							return {
								data: {
									httpStatusCode,
									data: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message,
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: "No response received",
				});
			}
		} catch (error) {
			return rejectWithValue({
				message: "Something went wrong",
			});
		}
	},
);

export const updateInstagramAdsetStatus = createAsyncThunk<
  any,
	iInstagramAdsetCreateDTO,
	{ rejectValue: iStateMessage }
>(
	curriedGetThunkName("updateInstagramAdsetStatus"),
  async (payload, { rejectWithValue }) => {
    try {
      const response = await instagramAdsetSetup.updateAdsetStatus(payload);

      if (response?.httpStatusCode === 200) {
        return response.data;
      }

      return rejectWithValue({
        message:
          response?.message ||
          response?.error?.error_user_msg ||
          "Failed to update status",
      });
    } catch (error: any) {
      return rejectWithValue({
        message:
          error?.response?.data?.error?.error_user_msg ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
    }
  }
);
